var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map",attrs:{"id":"tdtMap"}}),_c('div',{staticClass:"tianditu-copyright"},[_c('img',{staticClass:"tianditu-logo",attrs:{"src":"/image/logo.png","alt":"天地图"}}),_c('span',{staticClass:"tianditu-license"},[_vm._v("GS (2025) 1508号 - 甲测资字11110974")])])])
}]

export { render, staticRenderFns }